






























































































import { Component, Prop, Vue , Watch } from 'vue-property-decorator';

// TODO document2
import { Page } from '@/model/document2/page/page';
import DesignPreview from './designPreview/designPreview.vue';
import DesignBorder from './designBorder/designBorder.vue';

import * as def from '@/definitions'
import { Design } from '@/model/document2/page/surface/design/design';
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Rectangle } from '@/utilityModels/rectangle'
import { UserConfig } from '@/model/userConfig/userConfig';

import { MapHelper } from '@/helper/mapHelper';
import { UnitHelper } from '@/helper/unitHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { ImageHelper } from '@/helper/imageHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { MathHelper } from '@/helper/mathHelper';

@Component({
  components: {
        DesignPreview,
        DesignBorder
    },
})
export default class PagePreview extends Vue
{
    // ページ表示領域の基準サイズ。このサイズに収まるサイズが100%
    static readonly PAGE_BASE_WIDTH = 500;
    static readonly PAGE_BASE_HEIGHT = 700;
    // 固定pxとなるウィンドウサイズ
    static readonly FIXED_PX_BASE_WIDTH = 900;
    static readonly FIXED_PX_BASE_HEIGHT = 640;

    @Prop() private documentRotate! : number;
    @Prop() private page! : Page;
    @Prop() private isReverse! : boolean;
    @Prop() private isBorderVisible! : boolean;

    // ページサイズのフィックス
    private getFixedPageSize() : { width : number, height : number }
    {
        var width = this.page.width;
        var height = this.page.height;
        if(this.isRendering && UserAgentHelper.isMobile())
        {
            // モバイルの出力の場合
            // ハガキサイズのとき 148.5mm -> 148mm にする
            if(MathHelper.equals(this.page.width, 148.5) && MathHelper.equals(this.page.height, 100))
            {
                width = 148;
            }
            else if(MathHelper.equals(this.page.height, 148.5) && MathHelper.equals(this.page.width, 100))
            {
                height = 148;
            }
        }

        return { width : width, height : height };
    }

    private getBorderVisible()
    {
        // レンダリング中はプロパティに従う
        if(this.isRendering) { return this.isBorderVisible; }

        // それ以外は必ず表示
        return true;
    }
    @Prop() private borderColor! : ColorConstruct;
    private getBorderColor(position : number)
    {
        // ボーダー表示状態ならボーダーカラー
        if(this.isBorderVisible) { return this.borderColor; }

        // それ以外は選択状態で切り替える
        var selectedColor = this.systemBorderColor;
        var unselectedColor = new ColorConstruct(151, 151, 151);
        return this.page.currentDesignPosition == position ? selectedColor : unselectedColor;
    }
    private get systemBorderColor()
    {
        var buttonColorRgb = this.$store.getters.userConfigColors.buttonColorRgb;
        return new ColorConstruct(buttonColorRgb.r, buttonColorRgb.g, buttonColorRgb.b);
    }

    @Prop({default: 2}) private borderWidth! : number;
    @Prop({default: true}) private isFrameImageVisible! : boolean;
    @Prop({default: false}) private isRendering! : boolean;
    @Prop({default : false}) private isRenderingOnClient!: boolean;
    @Prop({default: false}) private isWebfontImported!: boolean;
    @Prop({default: 100}) private zoomScale! : number;
    @Prop({default: false}) private isControllable! : boolean;
    @Watch('zoomScale')
    onZoomScaleChanged(val: number, oldVal: number)
    {
        this.adjustFrameSize();
        this.$nextTick(() => this.adjustFramePosition());
    }
    @Prop({default: false}) private isAutoZoom! : boolean;
    @Watch('isAutoZoom')
    onIsAutoZoomChanged(val: boolean, oldVal: boolean)
    {
        if(val) { this.autoResize(); }
    }

    private get masterClassName()
    {
        return UserAgentHelper.isMobile() ? "print-setting-page-preview-m" : "print-setting-page-preview";
    }

    private get userConfig() : UserConfig
    {
        return this.$store.getters.userConfig;
    }

    private pageFrameStyle = {};

    private get surface() { return this.page.getSurface(this.isReverse); }

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private mm2px(mm : number)
    {
        return this.isRendering ? UnitHelper.convert(mm, "mm", "px", 72) : UnitHelper.convert(mm, "mm", "px");
    }

    private getBaseFrameSize()
    {
        return { width: this.getPagePreviewBaseWidth(), height: this.getPagePreviewBaseHeight() };
    }

    private getPagePreviewBaseWidth()
    {
        // ページ幅
        var pageWidth = this.getFixedPageSize().width;
        // mm -> pt
        var pageWidthPt = UnitHelper.convert(pageWidth, "mm", "pt");
        // この値がpxと一致するような幅
        return pageWidthPt;
    }

    private getPagePreviewBaseHeight()
    {
        // ページ幅
        var pageHeight = this.getFixedPageSize().height;
        // mm -> pt
        var pageHeightPt = UnitHelper.convert(pageHeight, "mm", "pt");
        // この値がpxと一致するような幅
        return pageHeightPt;
    }

    // 自動リサイズする
    private autoResize()
    {
        if(UserAgentHelper.isMobile())
        {
            // モバイルのみ、用紙サイズをもとにしてフレキシブルに計算する
            var pageWidthPx = UnitHelper.convert(this.page.width, "mm", "pt");
            var pageHeightPx = UnitHelper.convert(this.page.width, "mm", "pt");
            var wScale = (window.innerWidth - 16 * 2) / pageWidthPx;
            var hScale = (window.innerHeight - 16 * 2) / pageHeightPx;
            zoomScale = Math.min(wScale, hScale) * 100;
        }
        else
        {
            // サイズの調整
            var wScale = (Math.max(window.innerWidth, PagePreview.FIXED_PX_BASE_WIDTH) - 280) / PagePreview.PAGE_BASE_WIDTH;
            var hScale = (Math.max(window.innerHeight, PagePreview.FIXED_PX_BASE_HEIGHT) * 0.85  - 216) / PagePreview.PAGE_BASE_HEIGHT;
            var zoomScale = Math.min(wScale, hScale) * 100;
        }
        // 整数化
        zoomScale = Math.floor(zoomScale);
        if(zoomScale < 25) { zoomScale = 25; }
        if(zoomScale > 1000) { zoomScale = 1000; }
        this.onDoCommand("changeZoomScale", { scale : zoomScale });
    }

    mounted()
    {
        window.addEventListener('resize', this.onResize);

        if(this.isAutoZoom)
        {
            this.autoResize();
        }
        this.adjustFrameSize();
        this.$nextTick(() => this.adjustFramePosition());
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize()
    {
        if(this.isAutoZoom)
        {
            this.autoResize();
        }
        this.$nextTick(() => this.adjustFramePosition());
    }

    // ズームを元にしてフレームの大きさを調整
    private adjustFrameSize()
    {
        var width = this.getBaseFrameSize().width * this.zoomScale / 100;
        var height = this.getBaseFrameSize().height * this.zoomScale / 100;
        this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "width", width + "px");
        this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "height", height + "px");
    }

    // フレームの位置を調整
    private adjustFramePosition()
    {
        var preview = this.$refs["print-setting-page-preview"] as Element;
        var pageFrame = this.$refs["page-frame"] as Element;
        if(preview != null && pageFrame != null)
        {
            if((preview.clientHeight >= pageFrame.scrollHeight && preview.clientWidth >= pageFrame.scrollWidth))
            {
                // 全体中央揃え
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(-50%, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(-50%, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(-50%, -50%)");
            }
            else if(preview.clientWidth >= pageFrame.scrollWidth)
            {
                // 左右のみ中央揃え
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "0");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(-50%, 0)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(-50%, 0)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(-50%, 0)");
            }
            else if(preview.clientHeight >= pageFrame.scrollHeight)
            {
                // 上下のみ中央揃え
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "0");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "50%");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(0, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(0, -50%)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(0, -50%)");
            }
            else
            {
                // 揃えない
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "position", "absolute");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "left", "0");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "top", "0");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "transform", "translate(0, 0)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "webkitTransform", "translate(0, 0)");
                this.pageFrameStyle = MapHelper.addOrReplace(this.pageFrameStyle, "msWebkitTransform", "translate(0, 0)");
            }
        }
    }

    // デザインを表示する
    private isVisibleDesign(position : number)
    {
        if(this.isRendering)
        {
            // レンダリング中は印刷可能設定
            var printable = this.page.getSurface(this.isReverse).isPrintable(position);
            return printable;
        }
        else
        {
            // 常に表示
            return true;
        }
    }

    // 印刷不可マーク
    private isVisibleNotPrintableMark(position : number)
    {
        if(this.isRendering)
        {
            // 常に非表示
            return false;
        }
        else
        {
            // 非レンダリング中は印刷可能設定
            var printable = this.page.getSurface(this.isReverse).isPrintable(position);
            return !printable;
        }
    }

    // viewBox幅
    private get viewWidth() : number
    {
        return this.mm2px(this.getFixedPageSize().width);
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return this.mm2px(this.getFixedPageSize().height);
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get designs()
    {
        var array = new Array();
        var surface = this.page.getSurface(this.isReverse);
        for(var i = 0; i < this.page.designMaxNumber; ++i)
        {
            var design = surface.getDesign(i);
            array.push({
                design : design,
                position : i,
                key : UuidHelper.getUuid()
            });
        }
        return array;
    }

    private getDesignRect(position)
    {
        return this.page.getSurface(this.isReverse).getDesignRect(position);
    }

    private getDesignRectScaled(position)
    {
        var rect = this.getDesignRect(position);
        var x = this.mm2px(rect.x);
        var y = this.mm2px(rect.y);
        var w = this.mm2px(rect.width);
        var h = this.mm2px(rect.height);
        return new Rectangle(x, y, w, h);
    }

    // デザインをクリック
    private onClickDesign(position : number)
    {
        // カレント変更
        this.page.currentDesignPosition = position;
    }

    // オフセット
    private get baseTransform()
    {
        var transform = "";

        var shiftX = 0;
        var shiftY = 0;

        if(this.isReverse)
        {
            // 裏
            shiftX = this.userConfig.printHorizontalDirectionReverse == "right" ? this.userConfig.printHorizontalPositionReverse : -this.userConfig.printHorizontalPositionReverse;
            shiftY = this.userConfig.printVerticalDirectionReverse == "down" ? this.userConfig.printVerticalPositionReverse : -this.userConfig.printVerticalPositionReverse;
        }
        else
        {
            // 表
            shiftX = this.userConfig.printHorizontalDirection == "right" ? this.userConfig.printHorizontalPosition : -this.userConfig.printHorizontalPosition;
            shiftY = this.userConfig.printVerticalDirection == "down" ? this.userConfig.printVerticalPosition : -this.userConfig.printVerticalPosition;
        }

        var shiftXScaled = this.mm2px(shiftX);
        var shiftYScaled = this.mm2px(shiftY);

        transform += "translate(" + shiftXScaled + " " + shiftYScaled + "),";

        // 拡大縮小
        var scaleX = this.userConfig.printRate / 100;
        var scaleY = scaleX;
        transform += "scale(" + scaleX + " " + scaleY + ")";

        return transform;
    }

    // frameImage
    private get frameImageSource()
    {
        // FrameImageを取得する
        var frameImage = this.page.getSurface(this.isReverse).getFrameImage(0);
        if(frameImage != "")
        {
            // 線幅、線色を適用する
            var borderWidth = this.isRendering ? UnitHelper.convert(1, "pt", "mm") : UnitHelper.convert(1, "pt", "mm");
            var borderColor = this.isBorderVisible ? this.borderColor : new ColorConstruct(151, 151, 151);
            var vectorEffect = this.isRendering ? "" : "non-scaling-stroke";
            frameImage = ImageHelper.changeBase64SVGStroke(frameImage, borderWidth, borderColor, vectorEffect);
        }
        return frameImage;
    }

    private get frameImageWidth()
    {
        var baseWidth = this.documentRotate == 90 || this.documentRotate == 270 ? this.page.height : this.page.width;
        return this.mm2px(baseWidth);
    }

    private get frameImageHeight()
    {
        var baseHeight = this.documentRotate == 90 || this.documentRotate == 270 ? this.page.width : this.page.height;
        return this.mm2px(baseHeight);
    }

    private get frameImageTransform()
    {
        var transform = "";

        // オフセット
        // 回転角ごと適切な位置補正を加える
        var dx = 0;
        var dy = 0;
        let pageRotate = this.isReverse ? 
            (-this.documentRotate + 360) % 360 : this.documentRotate;
        if(pageRotate == 90)
        {
            dx = this.mm2px(this.page.width);
        }
        else if(pageRotate == 180)
        {
            dx = this.mm2px(this.page.width);
            dy = this.mm2px(this.page.height);
        }
        else if(pageRotate == 270)
        {
            dy = this.mm2px(this.page.height);
        }
        transform += "translate(" + dx + " " + dy + "),";

        // 用紙回転角で回転
        transform += "rotate(" + pageRotate + ")";

        return transform;
    }

    private get frameMaskExtention() { return Math.ceil(UnitHelper.convert(0.5, "pt", "mm")); }

    // SVGImageを取得する
    public getSvgImage()
    {
        var base64 = ImageHelper.convertSVGElementToBase64(this.$refs.svg);
        DebugHelper.trace(this.viewWidth)
        return base64;
    }

    public getSvgElement() : SVGSVGElement
    {
        return this.$refs.svg as SVGSVGElement;
    }
}
